/*@ngInject*/
const ReportActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createReport = function (submissionId, reportName) {
        var url = `/rest/ExternalReport/${submissionId}/create?reportName=${encodeURIComponent(reportName)}`;

        return this.post(url);
    };

    this.deleteReport = function (reportId) {
        var url = `/rest/ExternalReport/${reportId}/delete`;

        return this.delete(url);
    };

    this.editReport = function (reportId) {
        var url = `/rest/ExternalReport/${reportId}/edit`;

        return this.post(url);
    };

    this.generateReport = function (reportId) {
        var url = `/rest/ExternalReport/${reportId}/generate`;

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('reportActionRepository', ReportActionRepository);
